export default __webpack_public_path__ + "static/granulationstrings-7f6cd5d86782041cbe3baca43c84bc91.png";